var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaq = function SvgFaq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6667 1.06519H4.33333C1.95 1.06519 0 2.98258 0 5.32606V35.1521C0 37.4956 1.95 39.413 4.33333 39.413H13L19.5 45.8043L26 39.413H34.6667C37.05 39.413 39 37.4956 39 35.1521V5.32606C39 2.98258 37.05 1.06519 34.6667 1.06519ZM21.6667 35.1521H17.3333V30.8913H21.6667V35.1521ZM26.2167 18.7478L24.2667 20.6652C22.5333 22.1565 21.6667 23.4347 21.6667 26.6304H17.3333V25.5652C17.3333 23.2217 18.2 21.0913 19.9333 19.6L22.5333 16.8304C23.4 16.1913 23.8333 15.1261 23.8333 13.8478C23.8333 11.5043 21.8833 9.58692 19.5 9.58692C17.1167 9.58692 15.1667 11.5043 15.1667 13.8478H10.8333C10.8333 9.16084 14.7333 5.32606 19.5 5.32606C24.2667 5.32606 28.1667 9.16084 28.1667 13.8478C28.1667 15.7652 27.3 17.4695 26.2167 18.7478Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faq.eaffbb9f.svg";
export { ForwardRef as ReactComponent };